import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { AuthService } from '../libs/auth/auth.service';

@Directive({
	selector: '[btHasRole]',
	standalone: true
})
export class HasRoleDirective {
	readonly #authService = inject(AuthService);
	readonly #viewContainer = inject(ViewContainerRef);
	readonly #templateRef = inject(TemplateRef<any>);

	@Input('btHasRole') set roles(requiredRoles: Array<string>) {
		const userRoles = this.#authService.userLoggedValue?.Roles ?? [];

		let hasPermission = requiredRoles.length === 0 || requiredRoles.some((role) => userRoles.includes(role));

		this.#viewContainer.clear();
		if (hasPermission) {
			this.#viewContainer.createEmbeddedView(this.#templateRef);
		}
	}
}
